import { render, staticRenderFns } from "./wordDialog.vue?vue&type=template&id=7184b31e&scoped=true&"
import script from "./wordDialog.vue?vue&type=script&lang=js&"
export * from "./wordDialog.vue?vue&type=script&lang=js&"
import style0 from "./wordDialog.vue?vue&type=style&index=0&id=7184b31e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184b31e",
  null
  
)

export default component.exports